import React, { useState, useEffect } from "react";
import "./App.css";
import { style, px } from "rosebox";
import { GameCard } from "./GameCard";

type game = {
  id: string;
  title: string;
  background: string;
  logo: string;
};

const App = () => {
  const [games, setGames] = useState<game[]>([]);

  useEffect(() => {
    const handleMessage = ({
      data,
    }: {
      data: { type: string; games: game[] };
    }) => {
      if (
        typeof data === "object" &&
        data?.type === "RECEIVE_GAMES" &&
        data.games
      )
        setGames(data.games);
    };
    window.addEventListener("message", handleMessage);

    window.top.postMessage({ type: "REQUEST_GAMES" }, "*");

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div
      className="App"
      style={style({
        display: "grid",
        gridTemplateColumns: "50% 50%",
        gridTemplateRows: "auto",
        overflowX: "hidden",
        padding: px(8),
      })}
    >
      {games?.map(
        (game) =>
          game?.id && (
            <GameCard
              onClick={() =>
                window.top.postMessage(
                  { type: "MINI_LAUNCH", gameId: game.id },
                  "*"
                )
              }
              logo={game.logo}
              title={game.title}
              background={game.background}
              key={game.id}
            />
          )
      )}
    </div>
  );
};

export default App;
